import React from 'react';

const Services = ({ skills }) => {
  const allSkills = [
    { title: 'Full-Stack Web Development', icon: '💻', list: ['End-to-end planning', 'Architecture', 'Deployment', 'Scaling'] },
    { title: 'Frontend Development', icon: '🎨', list: skills.frontend },
    { title: 'Backend Development', icon: '⚙️', list: skills.backend },
    { title: 'Database Management', icon: '💾', list: skills.database },
    { title: 'Tools & DevOps', icon: '🛠️', list: skills.tools },
     { title: 'UI/UX', icon: '🖥️📱', list: skills.UIUX },
  ];

  return (
    <div className="services-content">
     <h2 
    className="section-title"
    style={{ color: '#2ECC71',marginTop:'-50px' }} // Emerald Green Accent
>
    Our Services
</h2>
      <p className="section-subtitle">We build complete digital products powered by modern technology.</p>
      
      <div className="skills-grid">
        {allSkills.map((skill, index) => (
          <div className="skill-card" key={index}>
            <span className="skill-icon">{skill.icon}</span>
            <h3>{skill.title}</h3>
            <ul>
              {skill.list.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services; // 🔥 CRITICAL: Default export